module.exports = __webpack_public_path__ + "static/media/webdesign-services-img30.64b360ad.jpg";